import { render, staticRenderFns } from "./JianqiuStartList.vue?vue&type=template&id=4633730b&"
import script from "./JianqiuStartList.vue?vue&type=script&lang=js&"
export * from "./JianqiuStartList.vue?vue&type=script&lang=js&"
import style0 from "./JianqiuStartList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports